import { isIframe } from '@sravni/react-utils';
import { WebViewUserManager, IframeUserManager, UserManager } from '@sravni/utils/lib/auth';
import isWebview from 'is-ua-webview';

const authMeta = {
    customer: 'CreditSelectionFrontend',
    productName: 'Подбор кредита',
};

export const getUserManager = () => {
    if (isIframe()) {
        return new IframeUserManager({
            analytics: authMeta,
        });
    }

    if (isWebview(navigator.userAgent || navigator.vendor)) {
        return new WebViewUserManager({
            analytics: authMeta,
        });
    }

    return new UserManager({
        analytics: authMeta,
    });
};
